import React from 'react';

interface TeamAssignmentConflictBannerProps {
  conflictCount: number;
  visible: boolean;
}

const TeamAssignmentConflictBanner: React.FC<TeamAssignmentConflictBannerProps> = ({
  conflictCount,
  visible,
}) => {
  if (!visible || conflictCount <= 0) {
    return null;
  }

  const label = conflictCount === 1 ? 'conflict' : 'conflicts';

  return (
    <div
      className="rounded-md border border-amber-700 bg-amber-950/30 px-4 py-3 text-sm text-amber-100"
      data-testid="team-assignment-conflict-count-banner"
    >
      {conflictCount} team assignment {label} need review. LSC team assignments remain canonical
      until you choose a resolution.
    </div>
  );
};

export default TeamAssignmentConflictBanner;
